import Exercise from '@/api/exercise';
import Phoneme from '@/api/phoneme';
import SpeakingContent from '@/api/speakingContent';
import StressMarker from '@/api/stressMarker';
import { cloneDeep, isEmpty, isNil } from 'lodash';
import { createMediaField } from '../common/util';

async function copyStressMarkers(
  stressMarkers: StressMarker[],
  parent_id: number
) {
  try {
    const markers = stressMarkers.map((item) => {
      const marker = new StressMarker();
      marker.parent_exercise = parent_id;
      marker.score_type = item.score_type;
      marker.start_index = item.start_index;
      marker.end_index = item.end_index;
      marker.word_start_index = item.word_start_index;
      marker.word_end_index = item.word_end_index;
      return marker;
    });

    const jobs = markers.map((item) => item.save());
    await Promise.all(jobs);

    return markers;
  } catch (err) {
    console.log(err);
    return [];
  }
}

async function copyPhonemes(phonemes: Phoneme[], parent_id) {
  try {
    const markers = phonemes.map((item) => {
      const marker = new Phoneme();
      marker.parent_exercise = parent_id;
      marker.score_type = item.score_type;
      marker.start_index = item.start_index;
      marker.end_index = item.end_index;
      return marker;
    });

    const jobs = markers.map((item) => item.save());
    await Promise.all(jobs);

    return markers;
  } catch (err) {
    console.log(err);
    return [];
  }
}

export async function copySpeakingContent(
  exercise: Exercise,
  sourceSpeakingContent: SpeakingContent
) {
  if (isNil(exercise.speaking_content) || isNil(sourceSpeakingContent)) {
    return;
  }

  const speaking = exercise.speaking_content;
  speaking.parent_exercise = exercise.id;
  speaking.transcription = sourceSpeakingContent.transcription;
  speaking.example = sourceSpeakingContent.example;
  speaking.description = sourceSpeakingContent.description;
  speaking.transcript_arpabet = cloneDeep(
    sourceSpeakingContent.transcript_arpabet
  );
  speaking.sentence = sourceSpeakingContent.sentence;
  speaking.sentence_i18n = sourceSpeakingContent.sentence_i18n;
  speaking.lesson_video_list = cloneDeep(
    sourceSpeakingContent.lesson_video_list
  );
  speaking.lesson_video = cloneDeep(sourceSpeakingContent.lesson_video);
  speaking.padding_video_list = cloneDeep(
    sourceSpeakingContent.padding_video_list
  );
  speaking.padding_video = cloneDeep(sourceSpeakingContent.padding_video);

  const stressMarkers = await copyStressMarkers(
    sourceSpeakingContent.stress_marker_objects,
    exercise.id
  );

  const phonenemes = await copyPhonemes(
    sourceSpeakingContent.phoneme_objects,
    exercise.id
  );

  if (!isNil(stressMarkers)) {
    speaking.stress_marker_objects = stressMarkers;
    speaking.stress_markers = stressMarkers.map((item) => item.id);
  }

  if (!isNil(phonenemes)) {
    speaking.phoneme_objects = phonenemes;
    speaking.phonemes = phonenemes.map((item) => item.id);
  }

  const id = await speaking.save();

  if (!isEmpty(sourceSpeakingContent.audio_link)) {
    const mediaId = await createMediaField(
      sourceSpeakingContent.audio_link,
      id,
      'exercisespeakingcontent',
      'audio'
    );

    speaking.audio_path = mediaId;
  }

  return speaking.save();
}
